<template>
	<div class="user-topbar">
		<!-- 左侧欢迎语 -->
		<div class="welcome-text">
			<span class="text-gray">{{ $t('userTopBar.welcome') }}</span>
			<span class="text-blue">{{ $t('userTopBar.systemName') }}</span>
		</div>
		<!-- 右侧操作区 -->
		<div class="top-right">
			<!-- 语言切换 -->
			<div class="lang-switch" @click.stop="toggleLangMenu">
				<span>{{ currentLangLabel }}</span>
				<el-image :src="require('@/static/CodeBuddyAssets/31187_2080/8.svg')"></el-image>
				<transition name="lang-dropdown" @before-enter="onAnimStart" @after-enter="onAnimEnd"
					@before-leave="onAnimStart" @after-leave="onAnimEnd">
					<div v-show="showLangMenu" class="lang-dropdown">
						<div v-for="item in langArr" :key="item" class="lang-option"
							:class="{ active: $i18n.locale === item }" @click.stop="selectLanguage(item)">
							{{ item === 'zh' ? $t('lanZhTxt') : $t('lanEnTxt') }}</div>
					</div>
				</transition>
			</div>
			<!-- 消息图标 -->
			<el-image class="msg-icon" :src="require('@/static/CodeBuddyAssets/31187_2080/5.svg')"></el-image>
			<!-- 用户信息 -->
			<div class="user-profile" v-if="!(userInfo)" @click="link('/login')">
				<span class="username">{{ $t('login') }}</span>
			</div>
			<div class="user-profile" v-if="userInfo">
				<el-image class="avatar-frame" :src="userInfo.portrait"></el-image>
				<span class="username">{{ userInfo.name }}</span>
				<span class="member-id">{{ $t('userTopBar.memberId') }}{{userInfo.invitationCode}}</span>
			</div>
			<!-- 分隔图标 -->
			<el-image class="divider-icon" :src="require('@/static/CodeBuddyAssets/31187_2080/4.svg')"></el-image>
			<!-- 通知铃铛 -->
			<div v-if="userInfo" class="avatar-wrap" @click="link('/userPageLab/myNews')">
				<el-image :src="require('@/static/CodeBuddyAssets/31187_2080/2.svg')"></el-image>
				<!-- <el-image class="avatar-inner" :src="require('@/static/CodeBuddyAssets/31187_2080/3.svg')"></el-image> -->
			</div>
			<!-- 问号 -->
			<el-image class="bell-icon" :src="require('@/static/CodeBuddyAssets/31187_2080/1.svg')"></el-image>
			<!-- 退出 -->
			<el-image v-if="userInfo" class="exit-icon" :src="require('@/static/CodeBuddyAssets/31187_2080/6.svg')" @click="handleLogout"></el-image>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'UserPageTopBar',
		data() {
			return {
				langArr: ['zh', 'en'],
				showLangMenu: false,
				isAnimating: false
			}
		},
		computed: {
			currentLangLabel() {
				return this.$i18n.locale === 'zh' ? this.$t('lanZhTxt') : this.$t('lanEnTxt')
			}
		},
		methods: {
			toggleLangMenu() {
				if (this.isAnimating) return;
				this.showLangMenu = !this.showLangMenu
			},
			onAnimStart() {
				this.isAnimating = true
			},
			onAnimEnd() {
				this.isAnimating = false
			},
			selectLanguage(lang) {
				this.$i18n.locale = lang;
				localStorage.setItem('lang', lang);
				this.showLangMenu = false
			},
			closeLangMenu() {
				this.showLangMenu = false
			},
			// 退出登录
			async handleLogout() {
				try {
					await this.$confirm(this.$t('confirmDialog.logoutMsg'), this.$t('confirmDialog.logoutTitle'), {
						confirmButtonText: this.$t('confirmDialog.confirmBtn'),
						cancelButtonText: this.$t('confirmDialog.cancelBtn'),
						type: 'warning'
					})
					this.$store.commit('userMsg/tokenC', '')
					this.$store.commit('userMsg/userInfoC', '')
					this.$router.push('/login')
				} catch (err) {
					if (err !== 'cancel') {
						console.error(this.$t('confirmDialog.logoutErr'), err)
					}
				}
			}
		},
		mounted() {
			document.addEventListener('click', this.closeLangMenu)
		},
		beforeDestroy() {
			document.removeEventListener('click', this.closeLangMenu)
		},
	}
</script>

<style lang="scss" scoped>
	.user-topbar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 15.96rem;
		height: 0.88rem;
		padding: 0 0.32rem 0 0.32rem;
		background: #fff;
		border-radius: 0.12rem;
		box-sizing: border-box;

		.welcome-text {
			font-size: 0.20rem;

			.text-gray {
				color: #666666;
				font-weight: 400;
			}

			.text-blue {
				color: #0096FF;
				font-weight: 500;
			}
		}

		.top-right {
			display: flex;
			align-items: center;
			// gap: 0.12rem;
		}

		.lang-switch {
			position: relative;
			display: flex;
			align-items: center;
			cursor: pointer;
			font-size: 0.16rem;
			font-weight: 500;
			color: #333333;

			.el-image {
				width: 0.16rem;
				height: 0.16rem;
				margin-left: 0.04rem;
			}

			.lang-dropdown {
				position: absolute;
				top: 100%;
				left: 0;
				margin-top: 0.08rem;
				background: #fff;
				border-radius: 0.06rem;
				box-shadow: 0 0.04rem 0.12rem rgba(0, 0, 0, 0.15);
				overflow: hidden;
				z-index: 200;
				min-width: 1.20rem;
			}

			.lang-dropdown-enter-active,
			.lang-dropdown-leave-active {
				transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1), transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
				transform-origin: top center;
			}

			.lang-dropdown-enter,
			.lang-dropdown-leave-to {
				opacity: 0;
				transform: scaleY(0.92) translateY(-0.04rem);
			}

			@media (prefers-reduced-motion: reduce) {

				.lang-dropdown-enter-active,
				.lang-dropdown-leave-active {
					transition: none;
				}

				.lang-dropdown-enter,
				.lang-dropdown-leave-to {
					opacity: 1;
					transform: none;
				}
			}

			.lang-option {
				padding: 0.10rem 0.16rem;
				font-size: 0.14rem;
				color: #333;
				cursor: pointer;
				transition: background-color 0.2s, color 0.2s;

				&:hover {
					background: #f5f7fa;
					color: #0096FF;
				}

				&.active {
					color: #0096FF;
					font-weight: 600;
				}
			}
		}

		.msg-icon {
			width: 0.02rem;
			height: 0.14rem;
			margin: 0 32px;
		}

		.user-profile {
			position: relative;
			display: flex;
			align-items: center;
			// gap: 0.08rem;

			.avatar-frame {
				width: 0.32rem;
				height: 0.32rem;
				border-radius: 50%;
			}

			.username {
				font-size: 0.18rem;
				font-weight: 400;
				color: #333333;
				margin-right: 17px;
				margin-left: 12px;
			}

			.member-id {
				font-size: 0.18rem;
				font-weight: 400;
				color: #999999;
			}
		}

		.divider-icon {
			width: 0.02rem;
			height: 0.14rem;
			margin: 0 32px;
		}

		.avatar-wrap {
			position: relative;
			width: 0.28rem;
			height: 0.28rem;
			margin-right: 32px;

			.el-image:first-child {
				width: 100%;
				height: 100%;
			}

			.avatar-inner {
				position: absolute;
				left: 0.18rem;
				top: 0.02rem;
				width: 0.08rem;
				height: 0.08rem;
			}
		}

		.bell-icon {
			width: 0.28rem;
			height: 0.28rem;
			cursor: pointer;
			margin-right: 32px;
		}

		.exit-icon {
			width: 0.28rem;
			height: 0.28rem;
			cursor: pointer;
		}
	}
</style>